export default __webpack_public_path__ + "static/thumb-landscape-eff87f3bbd92308e39705d97502a3df4.jpg";